module.exports = __webpack_public_path__ + "static/img/pictureB.9dc5e8b1.png";